var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _rect6, _path11, _rect7, _path12, _path13, _path14, _rect8, _path15, _rect9, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInstall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 160,
    viewBox: "0 0 312 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 20.5,
    width: 23,
    height: 16,
    fill: "white",
    stroke: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 35.8846L59.5 35.8846L59.5 136.403L40 139.494L20.5 136.403L20.5 35.8846Z",
    fill: "white",
    stroke: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1613 72.2499L42.2032 72.2499L42.2032 75.4075C42.2032 76.6868 41.8366 77.6318 41.1462 78.2715C40.5095 78.8588 39.6477 79.1844 38.6873 79.1844C37.7268 79.1844 36.8003 78.8491 36.1636 78.2191C35.5599 77.6211 35.1603 76.7615 35.1603 75.4075L35.1603 72.2499L35.1613 72.2499ZM36.7465 75.3658C36.7465 76.0685 36.9079 76.4251 37.2097 76.7295C37.5654 77.0861 38.0078 77.2858 38.6654 77.2858C39.2801 77.2858 39.7334 77.1075 40.0891 76.7818C40.4228 76.4775 40.6171 76.1208 40.6171 75.3658L40.6171 74.0855L36.7455 74.0855L36.7455 75.3658L36.7465 75.3658Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1613 78.8573L42.2032 82.0362L42.2032 83.5569L35.1613 86.7358L35.1613 84.7325L36.2393 84.2915L36.2393 81.2279L35.1613 80.7976L35.1613 78.8573ZM37.7059 81.8153L37.7059 83.7032L39.9596 82.7903L39.9596 82.7273L37.7059 81.8143L37.7059 81.8153Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2402 91.9188C40.5102 91.4681 40.9306 90.6074 40.9306 89.6005C40.9306 89.0441 40.6716 88.5615 40.2192 88.5615C39.7231 88.5615 39.6802 89.3485 39.6045 90.0928C39.5178 91.3518 39.3455 93.3347 37.4266 93.3347C35.6472 93.3347 34.9458 91.9081 34.9458 90.1878C34.9458 88.4675 35.6252 87.2192 36.2509 86.3905L37.5342 87.3762C37.1895 87.8482 36.4233 88.9395 36.4233 90.1558C36.4233 91.0058 36.8009 91.4981 37.2642 91.4981C37.7713 91.4981 37.8679 90.9108 37.9437 90.0298C38.0732 88.4985 38.2346 86.7249 40.1216 86.7249C41.8681 86.7249 42.4181 88.3085 42.4181 89.6412C42.4181 91.0465 41.9329 92.2948 41.5553 92.9141L40.2392 91.9178L40.2402 91.9188Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2402 100.583C40.5102 100.132 40.9306 99.2715 40.9306 98.2645C40.9306 97.7082 40.6716 97.2255 40.2192 97.2255C39.7231 97.2255 39.6802 98.0125 39.6045 98.7569C39.5178 100.016 39.3455 101.999 37.4266 101.999C35.6472 101.999 34.9458 100.572 34.9458 98.8518C34.9458 97.1315 35.6252 95.8832 36.2509 95.0546L37.5342 96.0402C37.1895 96.5122 36.4233 97.6035 36.4233 98.8199C36.4233 99.6698 36.8009 100.162 37.2642 100.162C37.7713 100.162 37.8679 99.5749 37.9437 98.6939C38.0732 97.1626 38.2346 95.3889 40.1216 95.3889C41.8681 95.3889 42.4181 96.9726 42.4181 98.3052C42.4181 99.7106 41.9329 100.959 41.5553 101.578L40.2392 100.582L40.2402 100.583Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2032 101.894L42.2032 108.251L40.6181 108.251L40.6181 105.996L35.1613 105.996L35.1613 104.16L40.6181 104.16L40.6181 101.894L42.2032 101.894Z",
    fill: "#909090"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3795 119.739C35.6243 118.911 34.9448 117.673 34.9448 116.162C34.9448 113.865 36.6275 112.344 38.6869 112.344C40.7463 112.344 42.4181 113.875 42.4181 116.11C42.4181 117.369 41.9219 118.648 41.2106 119.53L39.9811 118.429C40.5201 117.789 40.833 116.961 40.833 116.341C40.833 115.072 39.8516 114.254 38.676 114.254C37.5003 114.254 36.5189 115.093 36.5189 116.394C36.5189 117.191 37.0041 118.02 37.587 118.628L36.3795 119.739Z",
    fill: "#909090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.561 122.069L42.2032 124.765L42.2032 127.094L39.4106 124.188L35.1613 127.514L35.1613 125.237L38.1911 122.897L37.3821 122.069L35.1603 122.069L35.1603 120.222L42.2023 120.222L42.2023 122.069L39.56 122.069L39.561 122.069Z",
    fill: "#909090"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1613 108.281L35.1613 110.44L42.2032 111.943L42.2032 109.783L35.1613 108.281Z",
    fill: "#909090"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6155 112.456L44.6155 110.297L42.9855 109.949L42.9855 112.108L44.6155 112.456Z",
    fill: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96046e-8,
    y: 0.707096,
    width: 6.65841,
    height: 6.65841,
    rx: 0.526316,
    transform: "matrix(0.707117 0.707096 -0.707117 0.707096 40.5001 42.3106)",
    stroke: "#909090"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96046e-8,
    y: 0.707096,
    width: 6.65841,
    height: 6.65841,
    rx: 0.526316,
    transform: "matrix(0.707117 0.707096 -0.707117 0.707096 47.3926 49.2052)",
    stroke: "#909090"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96046e-8,
    y: 0.707096,
    width: 6.65841,
    height: 6.65841,
    rx: 0.526316,
    transform: "matrix(0.707117 0.707096 -0.707117 0.707096 33.6074 49.2052)",
    stroke: "#909090"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.96046e-8,
    y: 0.707096,
    width: 6.65841,
    height: 6.65841,
    rx: 0.526316,
    transform: "matrix(0.707117 0.707096 -0.707117 0.707096 40.5001 56.0955)",
    stroke: "#909090"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 80,
    r: 31.5,
    fill: "white",
    stroke: "#909090"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 80,
    r: 28.5,
    fill: "white",
    stroke: "#DDDDDD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 68.5,
    r: 2.5,
    fill: "#909090"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 90.5,
    r: 2.5,
    fill: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 83,
    width: 5,
    height: 7,
    rx: 2,
    transform: "rotate(-180 94 83)",
    fill: "white",
    stroke: "#13AE67"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75 83L68 83C67.4477 83 67 82.5523 67 82L67 77C67 76.4477 67.4477 76 68 76L75 76L75 83Z",
    fill: "white",
    stroke: "#13AE67"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 85,
    width: 15,
    height: 11,
    rx: 3,
    transform: "rotate(-180 89 85)",
    fill: "white",
    stroke: "#13AE67"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79.5L67 79.5",
    stroke: "#13AE67"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.513 29C135.124 29 133.188 30.9028 133.188 33.25V120.75C133.188 127.515 127.605 133 120.719 133C113.832 133 108.25 127.515 108.25 120.75V96.5C108.25 88.768 101.87 82.5 94 82.5V77.5C104.681 77.5 113.339 86.0066 113.339 96.5V120.75C113.339 124.754 116.643 128 120.719 128C124.794 128 128.098 124.754 128.098 120.75V33.25C128.098 28.1414 132.314 24 137.513 24C142.713 24 146.929 28.1414 146.929 33.25V73.5C146.929 75.7091 148.751 77.5 151 77.5V82.5C145.941 82.5 141.839 78.4706 141.839 73.5V33.25C141.839 30.9028 139.903 29 137.513 29Z",
    fill: "white",
    stroke: "#909090"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.5 70.5L177.5 89.5L158 89.5C156.067 89.5 154.5 87.933 154.5 86L154.5 74C154.5 72.067 156.067 70.5 158 70.5L177.5 70.5Z",
    fill: "white",
    stroke: "#909090"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 75.5,
    width: 9,
    height: 4,
    rx: 1.5,
    transform: "rotate(90 154.5 75.5)",
    fill: "white",
    stroke: "#909090"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M230 62C231.933 62 233.5 63.567 233.5 65.5L233.5 93.5C233.5 95.433 231.933 97 230 97L218.5 97L218.5 62L230 62Z",
    fill: "white",
    stroke: "#13AE67"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 58,
    width: 43,
    height: 41,
    rx: 3.5,
    transform: "rotate(90 218.5 58)",
    fill: "white",
    stroke: "#13AE67"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M246 67C246.828 67 247.5 67.6716 247.5 68.5C247.5 69.3284 246.828 70 246 70L233.5 70L233.5 67L246 67Z",
    fill: "white",
    stroke: "#13AE67"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M246 89C246.828 89 247.5 89.6716 247.5 90.5C247.5 91.3284 246.828 92 246 92L233.5 92L233.5 89L246 89Z",
    fill: "white",
    stroke: "#13AE67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstall2);
export default __webpack_public_path__ + "static/media/ic-install-2.2f40389583dcbf027cfe9274bee03fba.svg";
export { ForwardRef as ReactComponent };